import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AddTokenInterceptor implements HttpInterceptor {
  constructor(private helperService: HelperService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if request already has NO_AUTHENTICATION headers - if so, skip token injection
    const authHeader = req.headers.get('Authorization');
    const auth2Header = req.headers.get('Authorization2');
    
    if (authHeader === 'NO_AUTHENTICATION' || auth2Header === 'NO_AUTHENTICATION') {
      return next.handle(req);
    }

    const email = localStorage.getItem(
      `CognitoIdentityServiceProvider.${environment.clientId}.LastAuthUser`
    );
    if (req.url.includes('s3')) return next.handle(req);

    return this.helperService.getToken().pipe(
      mergeMap((token) => {
        if (token) {
          // Use primary token (usEast1) if available, otherwise fallback to secondary (usWest2)
          const authToken = token.primary || token.secondary;
          const headers: any = {};

          if (authToken) {
            headers.Authorization = authToken;
          }

          // Set secondary header only if both tokens are available
          if (token.primary && token.secondary) {
            headers.Authorization2 = token.secondary;
          }

          req = req.clone({ setHeaders: headers });
        } else {
          req = req.clone({
            setHeaders: {
              Authorization: 'NO_AUTHENTICATION',
              Authorization2: 'NO_AUTHENTICATION',
            },
          });
        }
        return next.handle(req);
      })
    );
  }
}
